export var InputType;
(function (InputType) {
    InputType["NUMBER"] = "NUMBER";
    InputType["TEXT_AREA"] = "TEXT_AREA";
    InputType["SEARCH"] = "SEARCH";
    InputType["WITH_COPY_TO_CLIPBOARD"] = "WITH_COPY_TO_CLIPBOARD";
    InputType["DEFAULT"] = "TEXT";
    InputType["PASSWORD"] = "PASSWORD";
})(InputType || (InputType = {}));
//# sourceMappingURL=inputType.js.map